import React from 'react';
import { Divider, Skeleton, SkeletonImage, Space } from '@ag1/ui';
import styles from './SubscriptionMainCardSkeleton.module.scss';

const SubscriptionMainCardSkeletonDesktop = () => (
  <Space top={24} className={styles.containerDesktop}>
    <Space left={40} right={40}>
      <Space top={8} bottom={12} className={styles.row}>
        <Skeleton width={60} height={24} />
        <Space left={16} asMargin>
          {(className) => <Skeleton height={24} className={className} />}
        </Space>
      </Space>
      <Space top={8} bottom={8}>
        <Skeleton width={262} height={28} />
      </Space>
    </Space>
    <Space top={16} bottom={16}>
      <Divider />
    </Space>
    <Space top={16} left={40} right={40} bottom={32}>
      <div className={styles.row}>
        <Skeleton width={108} height={28} />
        <Space left={32} asMargin>
          {(className) => (
            <>
              <Skeleton width={211} height={28} className={className} />
              <Skeleton width={171} height={28} className={className} />
            </>
          )}
        </Space>
      </div>
      <Space top={24} bottom={24} className={styles.row}>
        <SkeletonImage width={160} aspectRatio={1.3333} className={styles.image} />
        <Space left={24}>
          <Space top={8}>
            <Skeleton width={160} height={24} />
          </Space>
          <Space top={8}>
            <Skeleton width={160} height={20} />
          </Space>
          <Space top={8}>
            <Skeleton width={160} height={20} />
          </Space>
        </Space>
      </Space>
    </Space>
  </Space>
);

export default SubscriptionMainCardSkeletonDesktop;
